module.exports = __webpack_public_path__ + "img/water-rat-diving.2f423d6c6fc98d21ead01f9938193e35.jpg";